import * as Yup from 'yup';

export function contactValidator() {
  return Yup.object().shape({
    name: Yup
      .string()
      .required('Por favor, informe um nome de contato válido para prosseguir.'),
    phone_number: Yup
      .string()
      .nullable()
      .optional(),
    user_company_id: Yup
      .string()
      .nullable(),
    real_estate_id: Yup
      .string()
      .nullable(),
  });
}
